import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { GlobalsService } from '../../api/globals.service';
import { NavController, AlertController } from '@ionic/angular';
import { Router } from '@angular/router';
import { ForumsService } from '../../services/forums.service';
import { AuthService } from 'src/app/services/auth.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { PathLocationStrategy } from '@angular/common';

@Component({
  selector: 'app-create-forums',
  templateUrl: './create-forums.component.html',
  styleUrls: ['./create-forums.component.scss'],
})
export class CreateForumsComponent implements OnInit {

  @Output() reload = new EventEmitter<boolean>();

  private id:number;
  private auth_key:string;
  displayUserData:any;
  selectCategory:number;
  allCategories:any = [];
  countCategory=18;
  posCat:number;
  imgForo:string;
  selectIdCategory: string;
  imgSelect:number;
  srcImgSelect:string;
  myForums:any = [];
  forumsParticipate:any = [];

  srcImgs = [
    'assets/imagenes/iconos/i16.png',
    'assets/imagenes/iconos/i17.png',
    'assets/imagenes/iconos/i18.png'
  ]

  slidesOpts = {
   slidesPerView: 3.1,
   freeMode: true
  }
  

  colorForums:any=[
    [ '#effeff', '5px 5px #8cddeb'],
    [ '#f8f8fe', '5px 5px #bdade4'],
    [ '#fef0e6', '5px 5px #f9b781'],
    [ '#e9fdea', '5px 5px #9fe0a5'],
    [ '#fdedf4', '5px 5px #e2a4be'],
  ];


  forumForm: FormGroup;
  nombre_foro:string;
  first_comment:string;
  idCategory:string;
  constructor(
    public globalsService: GlobalsService,
    public navCtrl:NavController,
    private router:Router,
    private forumServices:ForumsService,
    private authService:AuthService,
    private alertCtrl: AlertController
  ) { }

  ngOnInit() {
    this.authService.userData$.subscribe((res: any) => {
      if(!this.displayUserData){        
        this.displayUserData =  res;
        this.loadVariables();
        this.obtenerCategorias();
        this.initForm();
      }
    });
  }
  

  obtenerCategorias() {
    this.forumServices.getAllCategoryForum(this.id,this.auth_key).subscribe(res=>{
      res.forEach(element => {
        let bc = this.setColor();
        element.backColor = bc[0];
        element.boxShadow = bc[1];
      });
    // 
      this.allCategories = res;
    });
  }

  loadVariables(){
    this.id = this.displayUserData?.id;
    this.auth_key = this.displayUserData?.auth_key;
  }

  initForm(){
    this.forumForm = new FormGroup({
      nombre_foro: new FormControl('',Validators.required),
      first_comment: new FormControl('',[Validators.required,Validators.minLength(0),Validators.maxLength(1000)]),
      idCategory: new FormControl(''),
      srcImg: new FormControl('')
    });
  }

  select(ev, idCat){    
    if(ev == this.selectCategory){
        this.selectCategory=null;
        this.selectIdCategory = null;
    }else{
      this.selectCategory = ev;
      this.selectIdCategory = idCat;
    }
  }

  selectImg(ev, srcImg){
    if(ev == this.imgSelect){
      this.imgSelect = null;
      this.srcImgSelect = null;
    }else{
      this.imgSelect = ev;
      this.srcImgSelect = srcImg;
    }
  }

  initVariables(){
    this.imgForo = "assets/imagenes/sistema/no-image.png";
    this.nombre_foro = "";
    this.selectIdCategory = null;
    this.first_comment = "";
    this.selectCategory=null;
  }

  createForum(){
    this.forumForm.value.idCategory = this.selectIdCategory;
    this.forumForm.value.srcImg = this.srcImgSelect;
    if(this.forumForm.valid){
      this.forumServices.crearForum(this.id,this.auth_key,this.srcImgSelect,this.forumForm.value).subscribe( (res:any) => {        
        if(!res.auth_key){  
        }else
        if(res.error){
          alert('ocurrió un error');
        }else
        if(res.validate){
          this.reloadFiltersForums();
          this.presentAlert();
          this.getMyForumsAndParticipate();
        }
      });
    }
    else{
    }
  }

  reloadFiltersForums(){
    this.reload.emit(true);
    //this.forumServices.forumUpdatedSource$.next(true);
  }

  getMyForumsAndParticipate(){
    this.forumServices.getMyForums(this.id,this.auth_key).subscribe(res=>{
      this.myForums = res.myForums;
      this.forumsParticipate = res.forumsParticipate;
      const lastForumId = this.myForums[this.myForums.length - 1].id; 
      this.forumServices.forumCreated(lastForumId); 
    });
  }

  setColor() { 
    let max =  (this.colorForums.length - 1);
    let posColor =  Math.floor(Math.random() * (max - 0)) + 0;
    return this.colorForums[posColor];
  }

  async presentAlert() {
    const alert = await this.alertCtrl.create({
      cssClass: 'my-custom-class',
      header: 'Hecho',
      message: 'El foro se creo satisfactoriamente',
      buttons: ['Aceptar']
    });
    this.initVariables();
    this.initForm();
    await alert.present();
    const { role } = await alert.onDidDismiss();
    
    this.router.navigate(['/forum']);
  }

}
